import React from 'react'

const CaseStudiesQuote = (props) => {
  return (
    <div className="row">
      <div className="col-md-10 col-md-offset-1">
        <div className="text-quote mt-5 mb-5">
            <div className="quote-bg-indigo">
              <div className="col-12 text-center">
                <h1 className="quote">{props.quote}</h1>
                <h4 className="quote-info">{props.quote_info}</h4>
              </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CaseStudiesQuote


// WEBPACK FOOTER //
// ./resources/assets/js/caseStudies/CaseStudiesQuote.js